exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "* {\n  margin: 0;\n  padding: 0; }\n\nbody {\n  line-height: 1.2; }\n\nli,\nol {\n  list-style: none; }\n\na, a:link, a:hover, a:active, a:visited {\n  color: #666; }\n\n.clearfix {\n  zoom: 1; }\n  .clearfix:after {\n    display: block;\n    content: '.';\n    height: 0;\n    overflow: hidden; }\n\nhtml {\n  font-size: 62.5%; }\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif;\n  font-size: 1rem;\n  color: #666; }\n  body.modal-open {\n    position: fixed;\n    width: 100%;\n    height: 100%; }\n\n.body {\n  min-height: 500px; }\n\n.footer {\n  text-align: center;\n  color: #999;\n  padding: 10px 0; }\n  .footer p {\n    margin: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/App.scss
// module id = 131
// module chunks = 28